// import { getEnvs } from '@/shared/utils';
// const { VITE_BUCKET_BASE } = getEnvs();
import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { PermissionsEnum } from "@/auth/interfaces";
import {
  ROUTER_PATHS,
  TABLE_CONSTANTS,
  emptyCellOneLevel,
  hasAllPermissions,
  // plantillaExcelENUM,
  useCheckPermissions,
  // useUploadFile,
} from "@/shared";
import {
  CustomSearch,
  GeneralTable,
  SingleTableBoxScene,
} from "@/shared/components/ui";
import { useTableFilter } from "@/shared/hooks/useTableFilter";
// import { CajaPrimaria } from "@/shared/interfaces";
import { useUiConfirmModalStore } from "@/store/ui";
import { SAVE_CAJA_PRIMARIA_PERMISSIONS } from "../../shared/constants";
import { CajaPrimaria, CajaPrimariaExtended } from '@/shared/interfaces/erp/configuracion-red/caja-primaria';
import { useDeleteCajaPrimaria, useFetchCajasPrimarias } from "@/shared/actions/erp/configuracion-red/cajaprimaria.actions";

export type CajaPrimariaPageProps = {};

const CajaPrimariaPage: React.FC<CajaPrimariaPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_view_olt);

  const returnUrlCajaPrimariaPage = ROUTER_PATHS.configuracionRED.cajaPrimariaNav;

  const navigate = useNavigate();

  ///* global state
  const setConfirmDialog = useUiConfirmModalStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    (s) => s.setConfirmDialogIsOpen
  );

  const deleteOLT = useDeleteCajaPrimaria();

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
    cleanFilter,
  } = useTableFilter();
  const { pageIndex, pageSize } = pagination;

  ///* fetch data
  const {
    data: CajaPrimariaPagingRes,
    isLoading,
    isRefetching,
  } = useFetchCajasPrimarias({
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      nombre: searchTerm,
    },
  });

  ///* handlers

  const onEdit = (cajaPrimaria: CajaPrimaria) => {
    setConfirmDialog({
      isOpen: true,
      title: "Editar Manga",
      subtitle: "¿Está seguro que desea editar esta Manga?",
      onConfirm: () => {
        setConfirmDialogIsOpen(false);
        navigate(`${returnUrlCajaPrimariaPage}/editar/${cajaPrimaria.id_caja_primaria}`);
      },
    });
  };

  const onDelete = (cajaPrimaria: CajaPrimaria) => {
    setConfirmDialog({
      isOpen: true,
      title: "Eliminar Manga",
      subtitle: "¿Está seguro que desea eliminar esta Manga?",
      onConfirm: () => {
        setConfirmDialogIsOpen(false);
        deleteOLT.mutate(cajaPrimaria.id_caja_primaria!);
      },
    });
  };

  const columns = useMemo<MRT_ColumnDef<CajaPrimariaExtended>[]>(
    () => [
      {
        accessorKey: "nombre",
        header: "Nombre",
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, "nombre"),
      },
      {
        accessorKey: "codigo",
        header: "código",
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, "codigo"),
      },
      {
        accessorKey: "estado_caja_primaria",
        header: "Estado Manga",
        size: 180,
        Cell: ({ row }) => row.original?.estado_caja_primaria?"ACTIVO":"INACTIVO",
      },
      // {
      //   accessorKey: "ciudad_nombre",
      //   header: "Ciudad",
      //   size: 200,
      //   Cell: ({ row }) => row.original?.ciudad_data?.nombre || "N/A",
      // },
      // {
      //   accessorKey: "zona_nombre",
      //   header: "Zona",
      //   size: 200,
      //   Cell: ({ row }) => row.original?.zona_data?.nombre || "N/A",
      // },
      // {
      //   accessorKey: "sector",
      //   header: "Sector",
      //   size: 180,
      //   Cell: ({ row }) => {
      //     return row.original.sector_data?.nombre || "N/A";
      //   },
      // },

      
      // {
      //   accessorKey: "descripcion",
      //   header: "Descripción",
      //   size: 180,
      //   Cell: ({ row }) => emptyCellOneLevel(row, "descripcion"),
      // },
    ],
    []
  );

  //CUSTOM HOOKS

  // const { fileInputRef: importOLTs, handleImportarOLT } = useUploadFile();
  // const { fileInputRef: importTroncales, handleImportarTroncales } =
  //   useUploadFile();

  return (
    <SingleTableBoxScene
      title="Manga"
      urlRedirect={`${returnUrlCajaPrimariaPage}/crear`}
      enableRedirect={hasAllPermissions([
        ...SAVE_CAJA_PRIMARIA_PERMISSIONS,
        PermissionsEnum.api_add_cajaprimaria,
      ])}
      //excel
      // enableUploadFile={true}
      // fileInputRef={[importOLTs, importTroncales]}
      // importationName={["Subir Manga", "Subir Troncales"]}
      // handleFileUpload={[handleImportarOLT, handleImportarTroncales]}
      // enableDownloadFile={true}
      // importationsQuantity={2}
      // urlDownloadPlantilla={[
      //   "/"+VITE_BUCKET_BASE+plantillaExcelENUM.PLANTILLA_OLT,
      //   "/"+VITE_BUCKET_BASE+plantillaExcelENUM.PLANTILLA_OLT_TRONCALES,
      // ]}
      // urlDownloadNameExcel={["plantilla_olt", "plantilla_olt_troncales"]}
      // messageInToolTips={[
      //   "El archivo a importar debe contener una sola hoja y cumplir con el formato indicado en la plantilla.",
      //   "El archivo a importar puede tener una hoja o más. Asegúrese que los nombres de las troncales, host y naps se encuentren en la fila y columna correcta según el formato de la plantilla.",
      // ]}
    >
      <CustomSearch
        onChange={onChangeFilter}
        value={globalFilter}
        text="por nombre de Manga"
        cleanFilter={cleanFilter}
      />

      <GeneralTable<CajaPrimaria>
        columns={columns}
        data={CajaPrimariaPagingRes?.data?.data || []}
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={CajaPrimariaPagingRes?.data?.count}
        // // actions ========
        enableColumnActions={hasAllPermissions([
          ...SAVE_CAJA_PRIMARIA_PERMISSIONS,
          PermissionsEnum.api_change_cajaprimaria,
        ])}
        actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH}
        // crud
        canEdit={hasAllPermissions([
          ...SAVE_CAJA_PRIMARIA_PERMISSIONS,
          PermissionsEnum.api_change_cajaprimaria,
        ])}
        onEdit={onEdit}
        canDelete={false}
        onDelete={onDelete}
      />
    </SingleTableBoxScene>
  );
};

export default CajaPrimariaPage;
